import React from 'react';
import styled from 'styled-components';

const Bar = styled.div`
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
  font-size: 0.95rem;
  text-align: right;
  position: relative;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

const Button = styled.button`
  padding: 0.4rem 0.8rem;
  font-size: 0.85rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &.accept {
    background-color: #28a745;
    color: white;
  }

  &.change {
    background-color: #ffc107;
    color: #212529;
  }
`;

const FontWarningBar = ({ onAccept, onChange }) => (
  <Bar>
    این فونت ممکن است در متن‌های طولانی یا برخی دستگاه‌ها خوانایی کمی داشته باشد. آیا مایل به ادامه با این فونت هستید؟
    <ButtonGroup>
      <Button className="change" onClick={onChange}>تغییر فونت</Button>
      <Button className="accept" onClick={onAccept}>موافقم</Button>
    </ButtonGroup>
  </Bar>
);

export default FontWarningBar;
